import {
  getAll,
  getAnalyticsParam,
  getPuid,
  getPuidFromAccessToken,
  initializeClickId,
  initializePuid,
  setAnalyticsParam,
} from "./methods";

export const AnalyticsService = {
  getAll,
  getOne: getAnalyticsParam,
  setOne: setAnalyticsParam,
  getPuid,
  getPuidFromAccessToken,
  initializePuid,
  initializeClickId,
};
